import { motion } from "framer-motion";
import ShareButtons from "../../../../utility/ShareButtons";

import useServiceData from "../../../../utility/useServiceData";
import FAQAccordion from "../../../../utility/FAQAccordion";
import QuickNavigation from "../../../../utility/serviceTemplateutility/QuickNavigation";

import WhyUs from "../../../../utility/serviceTemplateutility/WhyUs";
import CardDesign from "../../../../utility/serviceTemplateutility/CardDesign";
import ListDesign from "../../../../utility/serviceTemplateutility/ListDesign";
import MultiStepForm from "../../../../utility/serviceTemplateutility/MultiStepForm";
import { useLanguage } from "../../../../contextApi/languageContext";
import { useCart } from "../../../../contextApi/cartContext";
import { useGlobalData } from "../../../../contextApi/globalContextData";
import { bikinilaser } from "../../../../text-files/laser/bikinilaser.ts";
import OurTeam from "../../../homepage/OurTeam";
import Testimonials from "../../../homepage/Testimonials";
export default function BikiniLaserHairRemoval() {
  const serviceUrl = window.location.href;
  const data = useServiceData("Bikini Laser Hair Removal");
  const imageUrl = data?.image_url;

  const { language } = useLanguage();
  const { addToCart } = useCart();
  const { sectionsData } = useGlobalData();
  const content = bikinilaser[language];
  const shared = bikinilaser.shared;
  const faqData = [
    { heading: "Frequently Asked Questions" },
    {
      question: "Is bikini laser hair removal safe for sensitive skin?",
      answer:
        "Yes, the procedure is non-invasive and safe for sensitive areas like the bikini line. You can go ahead with the treatment easily.",
    },
    {
      question: "How many sessions are required for good results?",
      answer:
        "Most people require 4-6 sessions, but the time between sessions can vary between 4-6 weeks. So you need to always have a follow up with your dermatologist.",
    },
    {
      question: "Are there side effects?",
      answer:
        "There are minor redness or irritations but that usually resolves within hours. So, there is nothing to worry about. You can opt for the treatment at Elite Body Home Polyclinic.",
    },
  ];

  const Benefits = [
    {
      text: "Long-Lasting Results: Unlike shaving or waxing, laser hair removal provides results that last for several months, even years.",
    },
    {
      text: "Safe and Non-Invasive: The procedure is non-invasive and ideal for sensitive areas such as the bikini line and private parts.",
    },
    {
      text: "Reduces Ingrown Hairs: Laser hair removal reduces the formation of ingrown hairs.",
    },
    {
      text: "Can be Used for Most Skin and Hair Types: With new laser technology, there is wide applicability for most skin types and colors, including lighter shades of hair.",
    },
    {
      text: "Is Less Painful: Bikini laser hair removal is less painful compared to waxing or epilating.",
    },
  ];

  const bikiniLaserHairRemovalEligibility = [
    {
      text: "Appropriate Skin and Hair Type: Most effective for individuals with dark hair and fair to medium skin tones.",
    },
    {
      text: "Healthy Skin Condition: The bikini area should be free from infections, open wounds, or irritations.",
    },
    {
      text: "Not Pregnant or Breastfeeding: Laser hair removal is generally not recommended for pregnant or breastfeeding individuals due to hormonal changes affecting results.",
    },
    {
      text: "No Tanning: Avoid sun exposure or tanning beds for at least two weeks before the treatment to prevent skin sensitivity.",
    },
    {
      text: "No Waxing or Tweezing of Hair: Avoid waxing, tweezing, or epilating at least four weeks prior to the session since these procedures remove the hair follicle which is required for the laser to work.",
    },
    {
      text: "Free of Specific Medical Conditions: It is not advisable for people with certain medical conditions, such as skin cancer or tendencies for severe keloid scarring.",
    },
  ];

  const bikiniLaserHairRemovalPreparation = [
    {
      text: "Mark the Bikini Line: Outline the areas you want to treat and ensure they are clean and free of long hair.",
    },
    {
      text: "Shave: Shave the treatment area with a gentle razor and shaving oil to avoid irritation. Stretch the skin taut for a closer shave in sensitive areas like the labia.",
    },
    {
      text: "Do Not Expose to Sun: Avoid sun exposure for at least two weeks before the treatment to prevent skin sensitivity.",
    },
    {
      text: "Avoid Hair Removal Methods: Avoid waxing, threading, and plucking in the bikini area four weeks before treatment to ensure the hair follicle remains intact for the laser to target.",
    },
  ];

  const bikiniLaserHairRemovalResults = [
    {
      text: "Hair Reduction: Most clients see hair reduction after 4 to 6 sessions. The treated hair grows back thinner, lighter, and less dense.",
    },
    {
      text: "Long-Term Effects: A completed treatment guarantees smooth, hair-free skin for months or even years. Some infrequent follow-up treatments might be necessary to maintain the effects.",
    },
    {
      text: "Prevention of Ingrown Hairs: Laser hair treatment stops ingrowth, which is common with methods like waxing or shaving.",
    },
    {
      text: "Smooth and Even Skin Tone: Laser treatments may also facilitate smoother, more even-looking skin in the bikini area by reducing irritation and discoloration from traditional methods.",
    },
    {
      text: "Maintenance: After completing the bikini laser treatment, maintenance is significantly faster and easier because hair regrowth is drastically reduced.",
    },
  ];

  const afterBikiniLaserCare = [
    { heading: "After Care Instructions" },
    {
      para: "Post-treatment aftercare is required to maintain healing and the effect obtained. Follow these steps to avoid unnecessary hassles",
    },
    {
      title: "Avoid Heat",
      description:
        "Stay away from hot tubs, saunas, and intensive workouts for 48 hours.",
      icon: "fa-solid fa-temperature-high",
    },
    {
      title: "Use Gentle Products",
      description:
        "Avoid harsh soaps or exfoliants in the bikini area for a few days.",
      icon: "fa-solid fa-soap",
    },
    {
      title: "Moisturize the Area",
      description:
        "Apply aloe vera or a dermatologist-recommended moisturizer.",
      icon: "fa-solid fa-pump-soap",
    },
    {
      title: "Stay Sun-Safe",
      description:
        "Use sunscreen if the treated area is exposed to the sun to prevent sensitivity or heating issues.",
      icon: "fa-solid fa-sun",
    },
  ];

  return (
    <>
      <title>Bikini Laser Hair Removal -</title>
      <meta
        name="description"
        content="Are you tired of the unwanted hair in the bikini region? Worry not! We&#039;ve got you covered here at Elite Body Home. Traditional methods like shaving, waxing,"
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/bikini-laser-hair-removal/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Bikini Laser Hair Removal -" />
      <meta
        property="og:description"
        content="Are you tired of the unwanted hair in the bikini region? Worry not! We&#039;ve got you covered here at Elite Body Home. Traditional methods like shaving, waxing,"
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/bikini-laser-hair-removal/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-01-29T12:53:26+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/sfdsff.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/sfdsff.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Bikini Laser Hair Removal" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Bikini Laser Hair Removal -" />
      <meta
        name="twitter:description"
        content="Are you tired of the unwanted hair in the bikini region? Worry not! We&#039;ve got you covered here at Elite Body Home. Traditional methods like shaving, waxing,"
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/sfdsff.jpg"
      />
      <div
        className="min-vh-100 font-sans text-dark  mb-5 mx-3"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        {/* Hero Image Section */}
        {shared.images.main && (
          <section className="overflow-hidden ">
            <div className="position-relative mb-3">
              <img
                src={shared.images.main}
                alt="male energy Dubai"
                className="img-fluid w-100 rounded mt-2 "
                style={{
                  height: "500px",
                  objectFit: "cover",
                  objectPosition: "top",
                  border: "2px solid #c69933",
                  borderRadius: "100px",
                }}
              />
            </div>
          </section>
        )}

        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-1 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            {/* Main Content Column */}

            {/* Breadcrumbs */}
            <nav aria-label="breadcrumb" className="p-2">
              <ol className="breadcrumb">
                {content.breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === content.breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={
                      index === content.breadcrumbs.length - 1
                        ? "page"
                        : undefined
                    }
                  >
                    {index === content.breadcrumbs.length - 1 ? (
                      item
                    ) : (
                      <a href={index === 0 ? "/home" : "#"}>{item}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>

            {/* Title Section */}
            <div className="text-center my-2">
              <motion.h1
                className="display-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                {content.hero.title}
              </motion.h1>

              {content.hero.subtitle && (
                <motion.h2 className="fw-semibold mt-3">
                  {content.hero.subtitle}
                </motion.h2>
              )}

              {content.hero.description && (
                <motion.p className="lead mt-3">
                  {content.hero.description}
                </motion.p>
              )}
            </div>

            <QuickNavigation />

            {/* How It Works Section */}
            {content.howItWorks.title && (
              <motion.section className="my-5">
                <h2 className="h2 fw-bold mb-4 text-center">
                  {content.howItWorks.title}
                </h2>
                {content.howItWorks.description && (
                  <p className="text-muted text-center">
                    {content.howItWorks.description}
                  </p>
                )}
              </motion.section>
            )}

            {/* Introduction Image */}
            {shared.images.introductionImage && (
              <motion.div className="my-5">
                <div className="text-center">
                  <img
                    src={shared.images.introductionImage}
                    alt="fat freezing treatment dubai"
                    className="img-fluid rounded shadow"
                    style={{ maxHeight: "500px" }}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </motion.div>
            )}

            {/* Process Section */}
            <section id="process" className="my-5">
              <CardDesign carditems={content.procedureSteps} />
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="my-5">
              <ListDesign listitems={content.benefits} />
            </section>

            <section id="process" className="my-5">
              <ListDesign listitems={content.ingredients} />
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="my-5">
              <CardDesign listitems={content.eligibility} />
            </section>

            {/* Preparation Section */}
            <section id="preparations" className="my-5">
              <ListDesign listitems={content.preparationTips} />
            </section>

            {/* Results Section */}
            <section id="results" className="my-5">
              <ListDesign listitems={content.results} />
            </section>

            {/* Before & After Section */}
            {/* {shared.images.beforeAfter &&
              shared.images.beforeAfter.length > 0 && (
                <motion.section
                  className="my-5"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <BeforeAfterCarousel
                    language={language}
                    images={shared.images.beforeAfter}
                  />
                </motion.section>
              )} */}
            {/* Aftercare Section */}
            <section className="my-5">
              <ListDesign listitems={content.aftercareTips} />
            </section>

            {/* Product Card */}
            {shared.images.main && (
              <motion.div
                className="my-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden mx-auto"
                  style={{ maxWidth: "420px" }}
                >
                  <img
                    src={shared.images.main}
                    alt={content.meta.title}
                    className="card-img-top"
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center px-4 py-4">
                    <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                      {content.meta.title}
                    </h5>
                    <p className="card-text text-muted small">
                      {content.meta.description}
                    </p>
                    {/* <h6
                        className="text-success fw-bold mt-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {language === "en" ? "Price" : "السعر"}: AED{" "}
                        {shared.product.price}
                      </h6> */}
                    <button
                      className="btn rounded-pill px-4 py-2 mt-3 text-white fw-bold"
                      style={{
                        background: "#c69933",
                        border: "2px solid #c69933",
                      }}
                      onClick={() =>
                        addToCart({
                          ...shared.product,
                          image: shared.images.main,
                        })
                      }
                    >
                      {language === "en" ? "Add to Cart" : "أضف إلى السلة"}
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
            <WhyUs language={language} />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials
              data={sectionsData["Success Stories"]}
              language={language}
            />
            <FAQAccordion faqData={content.faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
}
